import React from 'react';

const DEFAULT_TITLE = 'Письмо отправлено';
const DEFAULT_LINES = [
  'Если письмо не пришло за 1-2 минуты, проверьте папки «Спам» и «Рассылки».',
  'В Яндекс Почте: Профиль -> Управление рассылками (или кнопка сверху).',
];
const DEFAULT_BUTTON_TEXT = 'Принял';

const EmailDeliveryHintAlert = ({
  show,
  isDark,
  onClose,
  title = DEFAULT_TITLE,
  lines = DEFAULT_LINES,
  buttonText = DEFAULT_BUTTON_TEXT,
  ariaLabel = 'Уведомление',
}) => {
  if (!show) {
    return null;
  }

  const textLines = Array.isArray(lines) && lines.length > 0 ? lines : DEFAULT_LINES;

  return (
    <div
      className={`email-delivery-hint-overlay ${isDark ? 'email-delivery-hint-overlay--dark' : 'email-delivery-hint-overlay--light'}`}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={`email-delivery-hint-card ${isDark ? 'email-delivery-hint-card--dark' : 'email-delivery-hint-card--light'}`}
        role="alertdialog"
        aria-modal="true"
        aria-label={ariaLabel}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="email-delivery-hint-title">{title}</div>
        {textLines.map((line, index) => (
          <p
            key={`email-delivery-hint-line-${index}`}
            className={`email-delivery-hint-text${index === textLines.length - 1 ? ' mb-0' : ''}`}
          >
            {line}
          </p>
        ))}

        <button
          type="button"
          className={`email-delivery-hint-btn ${isDark ? 'email-delivery-hint-btn--dark' : 'email-delivery-hint-btn--light'}`}
          onClick={onClose}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default EmailDeliveryHintAlert;
